module.exports = __webpack_public_path__ + "static/media/IMG-6.713836c9.jpg";